import PasswordValidatorLib from 'password-validator';

export interface PasswordRule {
  name: string;
  error: boolean;
  min?: number;
}

const schema = new PasswordValidatorLib();
schema.is().min(8).has().uppercase().has().lowercase().has().digits().has().symbols();

const allRules = [
  { name: 'min', min: 8 },
  { name: 'uppercase', min: 1 },
  { name: 'lowercase', min: 1 },
  { name: 'digits', min: 1 },
  { name: 'symbols', min: 1 },
  { name: 'confirm', min: 1 },
];

export class PasswordValidator {
  static validateAndThrow(password: string): void {
    const failedRules = schema.validate(password, { list: true }) as string[];
    if (failedRules.length > 0) {
      throw new Error('A senha não atende aos critérios de segurança');
    }
  }

  static validate(password: string): PasswordRule[] {
    const failedRules = schema.validate(password, { list: true }) as string[];
    return allRules
      .filter((rule) => rule.name !== 'confirm')
      .map((rule) => ({
        name: rule.name,
        min: rule.min,
        error: failedRules.includes(rule.name),
      }));
  }

  static validateWithConfirm(
    password: string,
    confirmPassword: string
  ): PasswordRule[] {
    const failedRules = schema.validate(password.trim(), { list: true }) as string[];
    return allRules.map((rule) => ({
      name: rule.name,
      min: rule.min,
      error:
        rule.name === 'confirm' ? password !== confirmPassword : failedRules.includes(rule.name),
    }));
  }
}
